var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFulcrumOrbLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1024x1024@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "49.9241314%",
    gradientTransform: "translate(0.5, 0.5), scale(0.9906, 1), rotate(44.0515), scale(1, 1.0076), translate(-0.5, -0.5)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04182F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010C1C",
    offset: "79.1275131%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28276C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.522525%",
    cy: "49.2425445%",
    fx: "49.522525%",
    fy: "49.2425445%",
    r: "49.2425445%",
    gradientTransform: "translate(0.4952, 0.4924), scale(0.6797, 1), rotate(-90), scale(1, 1.5128), translate(-0.4952, -0.4924)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04182F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010C1C",
    offset: "74.1012893%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82008F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.7428193%",
    cy: "50%",
    fx: "50.7428193%",
    fy: "50%",
    r: "50.0192488%",
    gradientTransform: "translate(0.5074, 0.5), scale(0.3574, 1), rotate(88.4104), scale(1, 2.6964), translate(-0.5074, -0.5)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04182F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010C1C",
    stopOpacity: 0.0533216783,
    offset: "72.4814248%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B3EA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1024x1024",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Orb-B1",
    transform: "translate(-0, 5.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Circle",
    fill: "url(#radialGradient-1)",
    opacity: 0.400297619,
    cx: 512,
    cy: 507,
    rx: 511.815468,
    ry: 507
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-2)",
    opacity: 0.402785528,
    cx: 512,
    cy: 519.5,
    rx: 512,
    ry: 348
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-3)",
    opacity: 0.403576079,
    cx: 512,
    cy: 505.5,
    rx: 512,
    ry: 183
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fulcrum",
    transform: "translate(189, 190)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "91 646 336 261 581 646 441.327103 646 336 389.333333 232.962617 646"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 279.745223 0 360 646 165.095541 646 8.40391825e-15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulcrumOrbLogo);
export default __webpack_public_path__ + "static/media/fulcrum-orb-logo.336221c3f02438b6ca859287ed60d2da.svg";
export { ForwardRef as ReactComponent };